module.exports = __webpack_public_path__ + "img/img-esfp.62430c3a.jpg";